const n = {
  name: "InfoFilled",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M1 12C1 5.92772 5.92772 1 12 1C18.0723 1 23 5.92772 23 12C23 18.0723 18.0723 23 12 23C5.92772 23 1 18.0723 1 12ZM13.25 7.25C13.25 6.56 12.69 6 12 6C11.31 6 10.75 6.56 10.75 7.25C10.75 7.94 11.31 8.5 12 8.5C12.69 8.5 13.25 7.94 13.25 7.25ZM13 10H9V12H11V15H9V17H15V15H13V10Z" fill="currentColor"/>
</svg>
  `
};
export {
  n as InfoFilled
};
